/**
 * The on/off toggle of the Rules STATUS column, shared: rule status, Keyword
 * Parser "Apple suggestions only", the Apple Ads credit-line switch. Styles
 * live on `.switch` in app.css.
 */
export function Switch({
  on, onChange, disabled = false, label, labelColor,
}: {
  on: boolean;
  onChange: (next: boolean) => void;
  disabled?: boolean;
  label?: React.ReactNode;
  labelColor?: string;
}) {
  return (
    <div className="row gap-8" style={{ alignItems: "center" }}>
      <div
        role="switch"
        aria-checked={on}
        aria-disabled={disabled || undefined}
        className={`switch${on ? " on" : ""}${disabled ? " disabled" : ""}`}
        onClick={() => { if (!disabled) onChange(!on); }}
      />
      {label != null && (
        <span style={{ fontSize: 11.5, fontWeight: 500, color: labelColor }}>{label}</span>
      )}
    </div>
  );
}
